import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// Disable the CRA service worker so users do not keep running stale bundles
// that reference retired Firebase Storage buckets.
serviceWorker.unregister();
